/**
 * PageLoader - Phase 16
 * Loading fallback for React.lazy Suspense
 */
import { Loader2 } from 'lucide-react'
import './PageLoader.css'

export function PageLoader() {
  return (
    <div className="page-loader">
      <div className="page-loader-content">
        <div className="page-loader-spinner">
          <Loader2 size={32} className="spinning" />
        </div>
        <span className="page-loader-text">Loading...</span>
      </div>
    </div>
  )
}

export function InlineLoader({ text = 'Loading...' }: { text?: string }) {
  return (
    <div className="inline-loader">
      <Loader2 size={20} className="spinning" />
      <span>{text}</span>
    </div>
  )
}
